/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "ExternalServiceAPI",
            "endpoint": "https://che51pqkdc.execute-api.us-east-1.amazonaws.com/gamma",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://o6v4xmqv7jcknmyc73d6d3ga3a.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-w7m4qsvxtbcfdamlr6x2broahi",
    "aws_cognito_identity_pool_id": "us-east-1:4e2a9dca-43ff-4acd-be96-b31055125841",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_dKRmEOHMr",
    "aws_user_pools_web_client_id": "68o8renbk99ere8gpkthskol81",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "trystateamplify38d0d6ac72214cbd9d2b2afcaef820ea185902-gamma",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
